module.exports = __webpack_public_path__ + "static/media/VG5000_Regular_web.06f3fbd0.ttf";